export default {
  'pages.appStore.refresh': 'Refresh',
  'pages.appStore.install': 'Deploy',
  'pages.appStore.cancel': 'Cancel',
  'pages.appStore.confirmInstall': 'Deploy to cluster',
  'pages.appStore.installCount': 'Deployed {count} times',
  'pages.appStore.spec':
    '{cpu} vCPU · {memory} MiB memory · {storage} GiB storage',
  'pages.appStore.installTitle': 'Deploy {name}',
  'pages.appStore.installSuccess': 'Deployment "{name}" submitted',
  'pages.appStore.installSuccessDescription':
    'The service is being created in your enterprise cluster and usually starts within a minute or two. Check its status and access URL under My deployments.',
  'pages.appStore.continueBrowsing': 'Keep browsing',
  'pages.appStore.viewDeployments': 'View my deployments',
  'pages.appStore.title': 'Deployment Templates',
  'pages.appStore.description':
    'Deploy databases, caches, and devops tools into your enterprise cluster in one click.',
  'pages.appStore.searchPlaceholder': 'Search by name, tag, or description',
  'pages.appStore.empty': 'No matching apps found',
  'pages.appStore.allCategories': 'All',
  'pages.appStore.category.database': 'Database',
  'pages.appStore.category.cache': 'Cache',
  'pages.appStore.category.storage': 'Storage',
  'pages.appStore.category.messaging': 'Messaging',
  'pages.appStore.category.devtools': 'Dev tools',
  'pages.appStore.category.monitoring': 'Monitoring',
  'pages.appStore.category.other': 'Other',
  'pages.appStore.field.name': 'Deployment name',
  'pages.appStore.field.nameHelp':
    'Also used as the in-cluster service name. Cannot be changed after deployment.',
  'pages.appStore.field.nameRequired': 'Enter a deployment name',
  'pages.appStore.field.nameInvalid':
    'Use lowercase letters, digits, and hyphens, start with a letter, up to 40 characters',
  'pages.appStore.field.description': 'Description',
  'pages.appStore.field.inputs': 'Initialization parameters',
  'pages.appStore.field.inputRequired': 'Enter {label}',
  'pages.appStore.deployments.title': 'My deployments',
  'pages.appStore.deployments.description':
    'Apps and services deployed in your enterprise cluster with public and internal access.',
  'pages.appStore.deployments.name': 'Deployment name',
  'pages.appStore.deployments.type': 'Type / Source',
  'pages.appStore.deployments.status': 'Status',
  'pages.appStore.deployments.endpoint': 'Access URL',
  'pages.appStore.deployments.spec': 'Size',
  'pages.appStore.deployments.createdBy': 'Deployed by',
  'pages.appStore.deployments.createdAt': 'Deployed at',
  'pages.appStore.deployments.actions': 'Actions',
  'pages.appStore.deployments.delete': 'Delete',
  'pages.appStore.deployments.deleteTitle': 'Delete deployment "{name}"?',
  'pages.appStore.deployments.deleteDescription':
    'This will delete data volumes as well and cannot be recovered.',
  'pages.appStore.deployments.empty': 'No deployments yet',
  'pages.appStore.deployments.installFromStore': 'Install from Template',
  'pages.appStore.deployments.customDeploy': 'Custom deploy',
  'pages.appStore.deployments.customTag': 'Custom',
  'pages.appStore.deployments.publicLink': 'Public link',
  'pages.appStore.deployments.internalPrefix': 'Internal',
  'pages.appStore.status.running': 'Running',
  'pages.appStore.status.pending': 'Starting',
  'pages.appStore.status.failed': 'Error',
  'pages.appStore.status.stopped': 'Not running',
  'pages.appStore.status.unknown': 'Cluster not connected',
  'pages.appStore.status.paused': 'Paused',
  'pages.appStore.deployments.edit': 'Edit',
  'pages.appStore.deployments.more': 'More',
  'pages.appStore.deployments.restart': 'Restart',
  'pages.appStore.deployments.pause': 'Pause',
  'pages.appStore.deployments.start': 'Start',
  'pages.appStore.deployments.autoscalingTag': 'Auto {min}–{max}',
  'pages.appStore.deployments.restartTitle': 'Restart "{name}"?',
  'pages.appStore.deployments.restartDescription':
    'All instances are recreated one by one. The service may be briefly unavailable.',
  'pages.appStore.deployments.restartDone': 'Restarting "{name}"',
  'pages.appStore.deployments.pauseTitle': 'Pause "{name}"?',
  'pages.appStore.deployments.pauseDescription':
    'All instances stop and the endpoints become unavailable. Configuration and volumes are kept, and you can start it again at any time.',
  'pages.appStore.deployments.pauseDone': 'Paused "{name}"',
  'pages.appStore.deployments.startTitle': 'Start "{name}"?',
  'pages.appStore.deployments.startDescription':
    'Restores the instance count and autoscaling settings from before the pause.',
  'pages.appStore.deployments.startDone': 'Starting "{name}"',
  'pages.appStore.deployments.deleteDone': 'Deleted "{name}"',
  'pages.appStore.form.createTitle': 'Deploy app',
  'pages.appStore.form.editTitle': 'Edit deployment · {name}',
  'pages.appStore.form.exportYaml': 'Export YAML',
  'pages.appStore.form.submitUpdate': 'Apply changes',
  'pages.appStore.form.viewForm': 'Form',
  'pages.appStore.form.viewYaml': 'YAML',
  'pages.appStore.form.copyYaml': 'Copy YAML',
  'pages.appStore.form.copied': 'Copied',
  'pages.appStore.form.section.basic': 'Basics',
  'pages.appStore.form.section.resource': 'Resources',
  'pages.appStore.form.section.network': 'Network',
  'pages.appStore.form.section.advanced': 'Advanced',
  'pages.appStore.form.summaryTitle': 'Resource summary',
  'pages.appStore.form.summaryInstances': 'Instances',
  'pages.appStore.form.summaryStorage': 'Volumes',
  'pages.appStore.form.enabled': 'On',
  'pages.appStore.form.disabled': 'Off',
  'pages.appStore.form.cores': '{value} cores',
  'pages.appStore.form.scalingMode': 'Instances',
  'pages.appStore.form.scalingFixed': 'Fixed',
  'pages.appStore.form.scalingAuto': 'Autoscaling',
  'pages.appStore.form.instances': 'Instances',
  'pages.appStore.form.autoTarget': 'Target',
  'pages.appStore.form.autoTargetCpuHint':
    'Scales out when average CPU usage exceeds this share of the limit, and scales in when it drops below.',
  'pages.appStore.form.autoTargetMemoryHint':
    'Scales out when average memory usage exceeds this share of the limit, and scales in when it drops below.',
  'pages.appStore.form.instanceRange': 'Instance range',
  'pages.appStore.form.instanceRangeInvalid':
    'The maximum cannot be less than the minimum',
  'pages.appStore.form.sharedVolumeNoAuto':
    'Deployments with storage created by older versions do not support autoscaling',
  'pages.appStore.form.sharedVolumeSingle':
    'This deployment was created by an older version and all instances share one volume, so it can only run 1 instance.',
  'pages.appStore.form.networkHint':
    'An in-cluster address is generated after deployment. HTTP ports can be exposed publicly with an automatically issued HTTPS certificate.',
  'pages.appStore.form.containerPort': 'Container port',
  'pages.appStore.form.namePlaceholderHost': '<name>',
  'pages.appStore.form.commandHint': 'Leave empty to use the image default.',
  'pages.appStore.form.commandPlaceholder': 'e.g. /bin/sh -c',
  'pages.appStore.form.argsPlaceholder': 'e.g. sleep 10 && /entrypoint.sh',
  'pages.appStore.form.add': 'Add',
  'pages.appStore.form.envBulkEdit': 'Bulk edit',
  'pages.appStore.form.envBulkTitle': 'Edit environment variables',
  'pages.appStore.form.envBulkPlaceholder':
    'One variable per line, separated by = or :, for example:\nmongoUrl=127.0.0.1:8000\nredisUrl:127.0.0.1:8001\n- env1=test',
  'pages.appStore.form.envBulkInvalid':
    'Invalid variable name on line {lines}: use letters, digits and underscores, and do not start with a digit',
  'pages.appStore.form.envBulkCount':
    '{count} variables. Saving replaces the current list.',
  'pages.appStore.form.localStorage': 'Local storage',
  'pages.appStore.form.storageHint':
    'Each instance mounts its own volume. Data is not shared between instances.',
  'pages.appStore.form.storageImmutable':
    'Volumes cannot be changed after creation.',
  'pages.appStore.form.perInstanceVolume':
    'With multiple instances, each one gets its own volume and data is not shared between them. Make sure the app supports this.',
  'pages.appStore.form.addVolumeTitle': 'Add volume',
  'pages.appStore.form.volumeSize': 'Size',
  'pages.appStore.form.volumeSizeRange': 'Size range: 1–500 Gi',
  'pages.appStore.form.confirm': 'Confirm',
  'pages.appStore.form.fixErrors': 'Please fix the highlighted fields first',
  'pages.appStore.form.updateSuccess': 'Changes to "{name}" submitted',
  'pages.appStore.form.loadFailed':
    'Failed to load the deployment. It may have been deleted or the cluster is temporarily unavailable.',
  'pages.appStore.form.backToList': 'Back to deployments',
  'pages.appStore.detail.eventsTab': 'Events',
  'pages.appStore.detail.noPodsPaused':
    'This deployment is paused. Start it from the More menu in the list.',
  'pages.appStore.detail.restartPodTitle': 'Restart pod "{name}"?',
  'pages.appStore.detail.restartPodDescription':
    'The pod is deleted and recreated by the cluster.',
  'pages.appStore.detail.restartPodDone': 'Restarting pod "{name}"',
  'pages.appStore.events.type': 'Type',
  'pages.appStore.events.Warning': 'Warning',
  'pages.appStore.events.Normal': 'Normal',
  'pages.appStore.events.reason': 'Reason',
  'pages.appStore.events.object': 'Object',
  'pages.appStore.events.message': 'Message',
  'pages.appStore.events.count': 'Count',
  'pages.appStore.events.lastSeen': 'Last seen',
  'pages.appStore.events.warningsOnly': 'Warnings only',
  'pages.appStore.events.empty': 'No events',
  'pages.appStore.events.retentionHint':
    'By default the cluster keeps events for the last hour only.',
  'pages.appStore.logs.modeLive': 'Live',
  'pages.appStore.logs.modeSnapshot': 'Snapshot',
  'pages.appStore.logs.stream.connecting': 'Connecting',
  'pages.appStore.logs.stream.live': 'Streaming',
  'pages.appStore.logs.stream.ended': 'Ended',
  'pages.appStore.logs.stream.error': 'Disconnected',
  'pages.appStore.logs.searchPlaceholder': 'Search',
  'pages.appStore.logs.matchCount': '{count} matching lines',
  'pages.appStore.logs.onlyMatches': 'Only matching lines',
  'pages.appStore.logs.timestamps': 'Timestamps',
  'pages.appStore.logs.wrap': 'Wrap lines',
  'pages.appStore.logs.download': 'Download full log',
  'pages.appStore.logs.downloadFailed': 'Failed to download logs',
  'pages.appStore.logs.fullscreen': 'Full screen',
  'pages.appStore.logs.exitFullscreen': 'Exit full screen (Esc)',
  'pages.appStore.logs.loading': 'Loading logs…',
  'pages.appStore.logs.jumpToLatest': 'Jump to latest',
  'pages.appStore.deployments.detail': 'Details',
  'pages.appStore.deployments.scale': 'Scale',
  'pages.appStore.deployments.replicas': '{replicas} replicas',
  'pages.appStore.scale.title': 'Scale "{name}"',
  'pages.appStore.scale.submit': 'Apply',
  'pages.appStore.scale.replicas': 'Target replicas',
  'pages.appStore.scale.current': 'Current replicas: {replicas}',
  'pages.appStore.scale.storageLimit':
    'This deployment was created by an older version and all instances share one volume, so it can only run 1 instance.',
  'pages.appStore.scale.success': 'Scaled "{name}" to {replicas} replicas',
  'pages.appStore.detail.title': 'Deployment · {name}',
  'pages.appStore.detail.podsTab': 'Pods & metrics',
  'pages.appStore.detail.logsTab': 'Logs',
  'pages.appStore.detail.refresh': 'Refresh',
  'pages.appStore.detail.podName': 'Pod',
  'pages.appStore.detail.podStatus': 'Status',
  'pages.appStore.detail.restarts': 'Restarts',
  'pages.appStore.detail.cpu': 'CPU usage',
  'pages.appStore.detail.memory': 'Memory usage',
  'pages.appStore.detail.cpuUsage': '{used} cores / limit {limit} cores',
  'pages.appStore.detail.memoryUsage': '{used} MiB / limit {limit} MiB',
  'pages.appStore.detail.node': 'Node / IP',
  'pages.appStore.detail.startTime': 'Started',
  'pages.appStore.detail.viewLogs': 'Logs',
  'pages.appStore.detail.previousLogs': 'Previous run logs',
  'pages.appStore.detail.phase.Running': 'Running',
  'pages.appStore.detail.phase.Pending': 'Starting',
  'pages.appStore.detail.phase.Failed': 'Error',
  'pages.appStore.detail.metricsUnavailable':
    'metrics-server is not installed in the cluster, so CPU and memory usage are unavailable.',
  'pages.appStore.detail.noPods': 'No running pods',
  'pages.appStore.detail.autoRefreshHint': 'Refreshes every {seconds} seconds',
  'pages.appStore.detail.tailLines': 'Last {lines} lines',
  'pages.appStore.detail.emptyLogs': 'No log output',
  'pages.appStore.custom.image': 'Container image',
  'pages.appStore.custom.imagePlaceholder':
    'e.g. nginx:1.27 or harbor.3as.cn/app:v1',
  'pages.appStore.custom.imageRequired': 'Enter container image',
  'pages.appStore.custom.imageInvalid': 'Image reference cannot contain spaces',
  'pages.appStore.custom.memory': 'Memory',
  'pages.appStore.custom.replicasRequired': 'Enter replicas',
  'pages.appStore.custom.addPort': 'Add port',
  'pages.appStore.custom.protocol': 'Protocol',
  'pages.appStore.custom.publicAccess': 'Public access',
  'pages.appStore.custom.publicHttpOnly':
    'Public access is only supported for HTTP',
  'pages.appStore.custom.portRequired': 'Enter port number',
  'pages.appStore.custom.portDuplicate': 'Port numbers must be unique',
  'pages.appStore.custom.envGroup': 'Environment variables',
  'pages.appStore.custom.envKey': 'Variable name',
  'pages.appStore.custom.envValue': 'Value',
  'pages.appStore.custom.envKeyInvalid':
    'Start with letter or _, only letters, digits, and _',
  'pages.appStore.custom.envKeyDuplicate': 'Variable names must be unique',
  'pages.appStore.custom.mountPath': 'Mount path (absolute)',
  'pages.appStore.custom.mountPathInvalid':
    'Must be an absolute path starting with /',
  'pages.appStore.custom.mountPathDuplicate': 'Mount paths must be unique',
  'pages.appStore.custom.command': 'Command',
  'pages.appStore.custom.args': 'Arguments',
  'pages.appStore.custom.argsHelp':
    'Container arguments, separated by spaces or commas',
  'pages.appStore.custom.submit': 'Deploy',
  'pages.appStore.custom.success': 'Custom deployment "{name}" submitted',
  'pages.appStore.custom.envKeyRequired': 'Enter a variable name',
  'pages.appStore.custom.mountPathRequired': 'Enter a mount path',
  'pages.appStore.deployments.emptyDescription':
    'Install from a deployment template in one click, or deploy any container image with your own settings.',
  'pages.appStore.images.title': 'Image registry',
  'pages.appStore.images.description':
    'Browse container images in the shared platform registry and deploy any tag to your enterprise cluster.',
  'pages.appStore.images.name': 'Image',
  'pages.appStore.images.searchPlaceholder': 'Search by image name',
  'pages.appStore.images.address': 'Repository address',
  'pages.appStore.images.tagCount': 'Tags',
  'pages.appStore.images.lastPushedAt': 'Last pushed',
  'pages.appStore.images.actions': 'Actions',
  'pages.appStore.images.viewTags': 'View tags',
  'pages.appStore.images.empty': 'No images in the registry yet',
  'pages.appStore.images.refresh': 'Refresh',
  'pages.appStore.images.readOnlyHint':
    'The registry is managed by the platform. You can browse these images and deploy them.',
  'pages.appStore.images.tag': 'Tag',
  'pages.appStore.images.digest': 'Digest',
  'pages.appStore.images.size': 'Size',
  'pages.appStore.images.pushedAt': 'Pushed at',
  'pages.appStore.images.lastPulledAt': 'Last pulled',
  'pages.appStore.images.inUse': 'In use',
  'pages.appStore.images.inUseCount': '{count} deployments',
  'pages.appStore.images.deploy': 'Deploy',
  'pages.appStore.images.delete': 'Delete',
  'pages.appStore.images.cancel': 'Cancel',
  'pages.appStore.images.deleteTitle': 'Delete image tag "{name}"?',
  'pages.appStore.images.deleteDescription':
    'The tag can no longer be pulled. Copies already pulled to nodes are not affected.',
  'pages.appStore.images.deleteBlocked':
    'Deployments still use this tag. Delete them first.',
  'pages.appStore.images.deleted': 'Deleted {name}',
};
